/*
  AironiMenager — onglets de la fiche produit.

  Motif ARIA « tabs » complet : un seul onglet dans l'ordre de tabulation
  (tabindex roulant), les flèches déplacent la sélection, Début et Fin vont
  aux extrémités. Sans ce tabindex roulant, un visiteur au clavier devrait
  traverser tous les onglets avant d'atteindre le contenu.

  Le composant ne masque les panneaux qu'une fois enregistré : si le script
  ne charge pas, la fiche reste lisible de bout en bout (voir :defined dans
  section-am-onglets-produit.css).
*/

class AmOngletsProduit extends HTMLElement {
  connectedCallback() {
    this.onglets = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panneaux = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.onglets.length === 0) return;

    // Mobile : la barre défile ; un dégradé à droite signale les onglets cachés,
    // retiré quand on arrive au bout.
    const barre = this.querySelector('.am-onglets__barre');
    if (barre) {
      const majBord = () => {
        const reste = barre.scrollWidth - barre.clientWidth - barre.scrollLeft;
        barre.classList.toggle('am-onglets__barre--suite', reste > 4);
      };
      barre.addEventListener('scroll', majBord, { passive: true });
      window.addEventListener('resize', majBord);
      majBord();
    }

    // Un onglet peut déjà être marqué sélectionné côté Liquid ; sinon le premier.
    const depart = this.onglets.findIndex((o) => o.getAttribute('aria-selected') === 'true');
    this.selectionner(depart === -1 ? 0 : depart, { deplacerLeFocus: false, defiler: false });

    this.onglets.forEach((onglet, index) => {
      onglet.addEventListener('click', () => this.selectionner(index, { deplacerLeFocus: false, defiler: true }));
      onglet.addEventListener('keydown', (evenement) => this.auClavier(evenement, index));
    });
  }

  auClavier(evenement, index) {
    const dernier = this.onglets.length - 1;
    let cible = null;

    switch (evenement.key) {
      case 'ArrowRight':
        cible = index === dernier ? 0 : index + 1;
        break;
      case 'ArrowLeft':
        cible = index === 0 ? dernier : index - 1;
        break;
      case 'Home':
        cible = 0;
        break;
      case 'End':
        cible = dernier;
        break;
      default:
        return;
    }

    // Les flèches servent ici à changer d'onglet, plus à faire défiler la page.
    evenement.preventDefault();
    this.selectionner(cible, { deplacerLeFocus: true, defiler: true });
  }

  selectionner(index, { deplacerLeFocus, defiler }) {
    this.onglets.forEach((onglet, i) => {
      const actif = i === index;
      onglet.setAttribute('aria-selected', String(actif));
      onglet.tabIndex = actif ? 0 : -1;
    });

    this.panneaux.forEach((panneau, i) => {
      panneau.toggleAttribute('hidden', i !== index);
    });

    const onglet = this.onglets[index];
    if (deplacerLeFocus && onglet) onglet.focus({ preventScroll: true });

    // Sur mobile la barre défile : l'onglet choisi doit revenir dans le champ
    // de vision. On ne fait défiler QUE la barre, horizontalement :
    // scrollIntoView déplaçait aussi la page jusqu'aux onglets à l'ouverture
    // de la fiche (le visiteur arrivait en bas au lieu du haut).
    if (defiler && onglet) this.montrerDansBarre(onglet);
  }

  montrerDansBarre(onglet) {
    const barre = this.querySelector('.am-onglets__barre');
    if (!barre) return;
    const rb = barre.getBoundingClientRect();
    const ro = onglet.getBoundingClientRect();
    if (ro.left < rb.left) barre.scrollLeft -= rb.left - ro.left + 16;
    else if (ro.right > rb.right) barre.scrollLeft += ro.right - rb.right + 16;
  }
}

if (!customElements.get('am-onglets-produit')) {
  customElements.define('am-onglets-produit', AmOngletsProduit);
}
